import React, { useEffect, useRef } from 'react';
import Header from '../components/headerfull';
import { FooterMaximized } from 'components/footerfull';
import { FormikProvider, useFormik } from 'formik';
import { formSteps } from '../schemas';
import { CheckCircleIcon, Groove, Hands, TalentImage } from '../assets';
import { countries, countryCode } from '../constants';
import { useNavigate } from 'react-router-dom';
import SimpleSlider from '../components/company-slides';
import WorldMapStats from './parts/WolrdMapsStats';

import '../styles/additional.css';
import { HoverButton2 } from '../components/ui/Buttons/OutlineCopy';
import { CommentCaEnTete, CommentCaSteps } from './accueil';

import { Step1 } from 'components/parcours-steps';
  
import { RoundBlueOutline, RoundGreyPlain, RoundWhitePlain } from 'components/ui/Buttons/generic/GenericButton';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { stepsAtoms } from 'store';
import { global_domain_id } from './freelance/states';
import { post } from 'services/config';

gsap.registerPlugin(ScrollTrigger);

const setDescription = (desc: any) => {
    const el = document.querySelector("meta[name='description']");
    if(el!== null){
        el.setAttribute('content',desc);
    }
}

export default function Home2({type='non-default', isTeleOp= false}){
    const [domainStateID, setDomainStateID]= useRecoilState<any>(global_domain_id);

    useEffect(()=>{
        document.title= type==="freelance" ?
            "Inscription freelances - Trouvez des missions"
            :
            isTeleOp ?
                "Externalisation de vos appels & tâches à distance – Service clé en main"
                :
                "Inscription entreprises - Recrutez des freelances";

        const desc= type==="freelance" ?
            "Rejoignez Wall of Share, la plateforme qui met les freelances en relation avec des entreprises pour des projets stimulants et rémunérateurs."
            :
            isTeleOp ?
                "Besoin d’un call center externalisé ou d’un assistant virtuel ? Wall of Share s’occupe de tout : recrutement, pilotage, outils, reporting. Lancez votre solution sur-mesure rapidement."
                :
                "Inscrivez votre entreprise sur Wall of Share et trouvez rapidement les freelances les plus qualifiés pour vos projets.";
        setDescription(desc);

        if (isTeleOp) {
            setDomainStateID(25);
        }
    },[]);


    const navigate = useNavigate();
    const formik = useFormik({
        initialValues: {
            societe: '',
            nom_prenom: '',
            nom:'',
            prenom:'',
            mail: '',
            telephone:'',
            pays:''
        },
        validationSchema: formSteps['step1'](type === 'non-default'?'enterprise': 'freelance'),
        validateOnMount: false,
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: values => {
            console.log({values})
            
        },
        
    });

    const defaultCountryCode = 'fr'

    const {handleSubmit, handleChange, errors, values, setFieldValue}:any = formik;
    // console.log({errors});

    const history= useNavigate();
    const [steps]= useRecoilState(stepsAtoms);
    const domainID= useRecoilValue(global_domain_id);
    const stepsRef= useRef(null);

    useEffect(()=>{
        stepsRef.current= steps;
        // console.log(steps);
    }, [steps]);
    
    const goToThanks= () => {

        const stepsCurrent= stepsRef.current || steps;

        // console.log('Submit Stuff------------');
        console.log(stepsCurrent.step1.enterprise);
        const formValues= stepsCurrent.step1.enterprise;
        // console.log(domainID);

        const payLoad= {
            "company_id": formValues.societe,
            "fullname": formValues.nom_prenom,
            "email": formValues.mail,
            "phone": formValues.telephone,
            "country_id": formValues.countryCode,
            "id": domainID
        };

        post('/api/external-global-domain-request', payLoad).then(response => {
            console.log(payLoad);
            if ((response.status === 200) && (response.data)) {
                const data: any = response.data;
                console.log(response);
                if (data.result && data.result.status === "success") {
                    //Thanks
                    history('/merci');
                } else {
                    //Error
                    history('/erreur');
                }
            } else {
                //Error
                history('/erreur');
            }
        }).catch(errors => {
            console.error(errors);
            history('/erreur');
        });
    };

    const handleNext = isTeleOp ? goToThanks : ()=> navigate(type === 'non-default'?'/parcours-entreprise?stepId=2':'/parcours-freelance?stepId=2');

    // useEffect(()=>{
    //     if(values?.countryCode){
    //       const val = countryCode.find((el:any)=>el.label.toLowerCase() === values?.countryCode.toLowerCase())
    //       setFieldValue('telephone', `${val?.value.split(' ').shift()} ${values?.telephone.split(' ').slice(1).join(' ')??''}`)
    //     }
    //   },[values.countryCode])
    
    //   useEffect(()=>{
    //     const val= `${values?.telephone}`.split(' ')[0]
    //     const findout = countryCode.find((el:any)=>el.value.split(' ')[0].trim() === val.toLowerCase().trim())
    //     if(values?.telephone.length === 1 && values?.telephone[0]!='+'){
    //       setFieldValue('telephone', `+${values?.telephone}`)
    //     }else if(findout){
    //       setFieldValue('countryCode', findout.label.toLowerCase())
    //     }
    //   },[values.telephone])

    useGSAP(()=>{
        gsap.from(".l-fade-up", {
            y: 50,
            duration: 1,
            stagger: 0.2,
            opacity: 0,
            scrollTrigger: {
                trigger: ".l-fade-up",
                start: "top 80%",
                toggleActions: "play none play reverse"
            }
        });
        gsap.from(".l-fade-up-2", {
            y: 50,
            duration: 1,
            stagger: 0.2,
            opacity: 0,
            scrollTrigger: {
                trigger: ".l-fade-up-2",
                start: "top 80%",
                toggleActions: "play none play reverse"
            }
        });
        gsap.from(".l-fade-x", {
            x: 70,
            duration: 1,
            stagger: 0.2,
            opacity: 0,
            scrollTrigger: {
                trigger: ".l-fade-x",
                start: "top 80%",
                toggleActions: "play none play reverse"
            }
        });
    }, []);

    return (
        <>
            <Header type={type} />
            <div className={`${type === 'freelance' ? 'bg-[#F4F4F5]' : 'bg-primary-blue'} border-t border-[#F4F4F5] `} id="header-banner">
                <div className='lg:w-4/5 mx-auto px-8 lg:px-0 lg:py-[100px] py-[50px] gap-x-4 max-w-[1152px] lg:min-w-[1000px]'>
                    <div className='mt-10 '>
                        <div className='flex lg:flex-row flex-col-reverse flex-1 lg:space-x-8 justify-between items-center'>

                            <div className={`my-8 space-y-10 lg:pr-[4rem] lg:w-1/2 ${isTeleOp ? 'max-w-[592px] min-[1343px]:grow' : 'max-w-[592px] min-[1343px]:grow'}`}>
                                <LandingH1 isTeleOp={isTeleOp} type={type} isMobile={false} />

                                <div className='space-y-1  l-fade-up'>
                                    <div className={`lg:flex lg:space-x-3 space-y-3 lg:space-y-0 ${type === 'non-default' ? 'text-white' : 'text-black'} text-lg    font-semibold`}>
                                        <img src={CheckCircleIcon} alt='check circle icon' />
                                        <div>
                                            {
                                                isTeleOp ? <>Une solution clé en main, pensée pour les PME comme les grandes structures</>
                                                    :
                                                    type === 'non-default' ?
                                                        (
                                                            <>Excellence garantie à chaque collaboration</>
                                                        ) :
                                                        (
                                                            <>Accédez aux meilleures opportunités, sans compromis :</>
                                                        )
                                            }
                                        </div>
                                    </div>
                                    <div className={`text-md ${type === 'non-default' ? 'text-white' : 'text-[#888]'} font-thin`}>
                                        {
                                            isTeleOp ? <>Wall of Share gère l’ensemble de votre prospection ou de votre support client à distance : recrutement d’assistants virtuels et téléopérateurs, encadrement des équipes, installation d’outils adaptés, suivi quotidien des résultats.</>
                                            :
                                            type === 'non-default' ?
                                                (
                                                    <>
                                                        Travaillez avec des freelances évalués en continu pour s'assurer d'un niveau d'expertise et d'efficacité optimal.
                                                    </>
                                                ) :
                                                (
                                                    <>
                                                        Rejoignez une communauté d'élite où chaque projet est soigneusement sélectionné pour correspondre à vos compétences et à vos ambitions.
                                                    </>
                                                )
                                        }

                                    </div>
                                </div>

                                <div className='space-y-1 l-fade-up'>
                                    <div className={`lg:flex lg:space-x-3 space-y-3 lg:space-y-0 ${type === 'non-default' ? 'text-white' : 'text-black'} text-lg font-semibold`}>
                                        <img src={CheckCircleIcon} alt='check circle icon' />
                                        <div>
                                            {
                                                isTeleOp ? <>Des professionnels qualifiés, encadrés et opérationnels rapidement</>
                                                :
                                                type === 'non-default' ?
                                                    (
                                                        <>Talents de haute qualité, tarifs inégalés</>
                                                    ) :
                                                    (
                                                        <>Tarifs compétitifs et rémunération maximale :</>
                                                    )
                                            }
                                        </div>
                                    </div>
                                    <div className={`text-md ${type === 'non-default' ? 'text-white' : 'text-[#888]'} font-thin`}>
                                        {
                                            isTeleOp ? <>Vous bénéficiez d’une équipe dédiée, sélectionnée selon vos besoins métiers, pilotée par nos soins et prête à agir dès les premiers jours.</>
                                            :
                                            type === 'non-default' ?
                                                (
                                                    <>
                                                        Profitez des meilleurs freelances, rigoureusement sélectionnés et testés, à des prix défiant toute concurrence.
                                                    </>
                                                ) : (
                                                    <>
                                                        Recevez une rémunération qui reflète votre expertise, sans négociations frustrantes ou frais cachés. Vous méritez le meilleur, et nous vous le garantissons.
                                                    </>
                                                )
                                        }
                                    </div>
                                </div>

                                <div className='space-y-1 l-fade-up'>
                                    <div className={`lg:flex lg:space-x-3 space-y-3 lg:space-y-0 ${type === 'non-default' ? 'text-white' : 'text-black'} text-lg font-semibold`}>
                                        <img src={CheckCircleIcon} alt='check circle icon' />
                                        <div>
                                            {
                                                isTeleOp ? <>Aucun stress, aucun surcoût, aucun détour</>
                                                :
                                                type === 'non-default' ?
                                                    (
                                                        <>Simplicité et rapidité extrême</>
                                                    ) :
                                                    (
                                                        <>Développement de carrière accéléré :</>
                                                    )
                                            }
                                        </div>
                                    </div>
                                    <div className={`text-md ${type === 'non-default' ? 'text-white' : 'text-[#888]'} font-thin`}>
                                        {
                                            isTeleOp ? <>Vous remplissez ce formulaire, nous échangeons sur votre projet, et nous mettons tout en place avec vous, sans démarche complexe ni engagement flou.</>
                                            :
                                            type === 'non-default' ?
                                                (
                                                    <>
                                                        Inscrivez vous, trouvez le freelance idéal, et lancez votre projet en quelques minutes, sans aucune complexité.
                                                    </>
                                                ) : (
                                                    <>
                                                        Accédez à des projets variés et de haute qualité qui vous permettent de renforcer vos compétences et de bâtir une solide réputation.
                                                    </>
                                                )
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='bg-white rounded-3xl lg:flex-1 h-full max-w-500'>
                                <div className='pt-8 px-6 lg:px-10'>
                                    <div className='text-primary-blue font-semibold md:text-2xl text-3xl my-2.5'>
                                        {
                                            isTeleOp ?
                                            <h2>Confiez votre prospection téléphonique à Wall of Share !</h2>
                                            :
                                            <h2>Devenez {type === 'non-default' ? 'client' : 'freelance chez'} Wall&nbsp;of&nbsp;Share&nbsp;!</h2>
                                        }
                                    </div>
                                    <div className='text-[#6F6F6F] font-medium text-md'>
                                        {
                                            type === 'non-default' && !isTeleOp ?
                                                (
                                                    <>Créer votre profil entreprise sur Wall Of Share et publiez vos missions.</>
                                                ) :
                                                isTeleOp ?
                                                (
                                                    <>Remplissez ce formulaire pour discuter de votre projet d’externalisation et mettre en place votre équipe dédiée rapidement.</>
                                                ) :
                                                (
                                                    <>Trouvez des projets qui valorisent vos compétences et développent votre carrière.</>
                                                )
                                        }
                                    </div>
                                    <div className=''>
                                        <div className={isTeleOp ? '' : 'pb-[2rem]'}>
                                            <Step1 
                                                type={type === 'non-default'?'enterprise':'freelance'} 
                                                layout="mobile" inputClassName='!bg-[#F4F4F5] !my-2 ' 
                                                handleNext={handleNext}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={`${!isTeleOp && 'border-t border-[#F4F4F5]'} flex justify-between items-center pt-4 px-10 pb-5`}>
                                    {!isTeleOp && <div className='text-[#6F6F6F]'>Étape 1</div>}
                                    <HoverButton2 step={1} type={type === 'non-default' ? 'enterprise' : 'freelance'} className='font-normal' text={isTeleOp ? "Envoyer" : "Suivant"}/>
                                </div>
                            </div>


                            <LandingH1 isMobile={true} isTeleOp={isTeleOp} type={type}/>
                        </div>

                    </div>
                </div>
            </div>
            {!isTeleOp && <div className={`${type === 'non-default' ? 'bg-[#F4F4F5]' : ''}  py-[5.2rem] `}>
                <div className='lg:w-[76%] lg:px-0 px-8 mx-auto max-w-[1152px] lg:min-w-[1000px]'>
                    <CommentCa type={type}/>

                    <div className='flex justify-center my-6'>
                        {/* <HoverButton2 step='' type='freelance' text={type === 'non-default' ? `Lancez votre projet aujourd'hui` : 'Inscrivez-vous maintenant'} onClick={() => alert('ok')} /> */}
                        {
                            type=== 'non-default' ?
                            <RoundGreyPlain text="Lancez votre projet aujourd'hui" isButton={false} to={"#header-banner"} className="px-[1.6rem] py-[.6rem]" isHash={true}/>
                            :
                            <RoundWhitePlain text="Inscrivez-vous maintenant" isButton={false} to={"#header-banner"} className="px-[1.6rem] py-[.6rem]" isHash={true}/>
                        }
                    </div>
                </div>
            </div>}

            <div className='flex lg:flex-row flex-col lg:space-x-10 lg:w-4/5 px-8 lg:px-0 mx-auto py-[6rem] gap-x-6 max-w-[1152px] lg:min-w-[1000px] md:max-w-535'>
                <div className='overflow-hidden rounded-2xl flex-7_10'>
                    <img src={TalentImage} alt="talent_image" className='h-full object-cover' />
                </div>

                <div className='flex flex-col space-y-4 my-6 lg:my-0 flex-1 justify-center'>
                    <div className='font-bold text-3xl lg:w-4/5 l-fade-up-2'>
                        <h2>Accédez aux talents et à un support expert en continu</h2>
                    </div>
                    <div className='space-y-4'>
                        <div className='my-7 l-fade-up-2'>
                            <div className='flex lg:flex-row flex-col items-start space-y-3 lg:space-x-3 lg:space-y-0 lg:items-center'>
                                <img src={Groove} alt="" className='h-4' />
                                <div className='font-semibold text-2xl'>
                                    {
                                        type === 'non-default' ?
                                            (
                                                <>Accès aux meilleurs talents, où que vous soyez</>
                                            ) :
                                            (
                                                <>Contrats simplifiés et paiements sécurisés </>
                                            )
                                    }
                                </div>
                            </div>
                            <div className='text-[#6F6F6F] text-[1.05rem] font-medium'>
                                {
                                    type === 'non-default' ?
                                        (
                                            <>Collaborez avec des freelances qualifiés du monde entier, et trouvez rapidement le profil parfait qui répond à vos besoins.</>
                                        ) :
                                        (
                                            <>Gagnez du temps et de la tranquillité d'esprit avec des contrats standardisés et des paiements sécurisés à chaque mission.</>
                                        )
                                }
                            </div>
                        </div>
                        <div className='my-7 l-fade-up-2'>
                            <div className='flex lg:flex-row flex-col items-start space-y-3 lg:space-x-3 lg:space-y-0 lg:items-center'>
                                <img src={Hands} alt="" className='h-6' />
                                <div className='font-semibold text-2xl'>
                                    {
                                        type === 'non-default' ?
                                            (
                                                <>Support dédié et proactif</>
                                            ) :
                                            (
                                                <>Support dédié 24/7 </>
                                            )
                                    }
                                </div>
                            </div>
                            <div className='text-[#6F6F6F] text-[1.05rem] font-medium'>
                                {
                                    type === 'non-default' ?
                                        (
                                            <>Une équipe d'experts disponible 24/7 pour vous accompagner et optimiser vos processus de recrutement et de gestion de projet.</>
                                        ) :
                                        (
                                            <>Vous n'êtes jamais seul. Notre équipe d'assistance est disponible à tout moment pour vous aider, que ce soit pour des conseils stratégiques ou une aide technique.</>
                                        )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                type === "non-default" && <WorldMapStats />
            }

            <div className='w-full mx-auto mb-[4rem] force-clip'>
                <SimpleSlider />
            </div>
            <FooterMaximized />
        </>
    );
}

const LandingH1= ({isMobile, type= 'non-default', isTeleOp= false}: {isMobile: boolean, type?: string, isTeleOp: boolean}) => {
    const cName= isMobile ? 'text-3xl text-white font-semibold my-8 lg:my-0 lg:hidden max-w-535' : 'text-2xl lg:text-4xl text-white font-semibold my-8 lg:my-0 hidden lg:block l-fade-up'
    return <><div className={cName}>
    <h1>

        {
            isTeleOp ?
                <><span className='bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 bg-clip-text text-transparent'>Externalisez votre prospection téléphonique</span> en toute simplicité avec Wall of Share</>
                :
                type === 'non-default' ? (
                    <>
                        Inscrivez votre entreprise et accédez aux meilleurs talents à <span className='bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 bg-clip-text text-transparent'>travers le&nbsp;monde.</span>
                    </>
                    ) : (
                    <>
                        <span className='text-black'>Rejoignez notre communauté de</span>   <span className='bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 bg-clip-text text-transparent'>freelances&nbsp;d'élite</span>
                    </>
                    )
        }
    </h1>
        {(isTeleOp && isMobile) && <div className="mt-[40px] l-fade-up"><RoundBlueOutline text="A partir de 600€/Freelance par mois" noCursor={true} className={`font-semibold leading-[100%] md:text-[22px] text-[15px] px-[27px] py-[10.5px]`}/></div>}
</div>
<div className={`${'hidden lg:block l-fade-up'}`}>
    {(isTeleOp && !isMobile) && <RoundBlueOutline text="A partir de 600€/Freelance par mois" noCursor={true} className={`font-semibold leading-[100%] md:text-[22px] text-[15px] px-[27px] py-[10.5px]`}/>}
</div>
</>
};

const CommentCa = ({ type }: any) => {
    return (
        <>
            <CommentCaEnTete type={type} />

            <CommentCaSteps type={type} />
        </>
    );
};